import { render, staticRenderFns } from "./AaprobarPostgrado.vue?vue&type=template&id=527e089e&scoped=true"
import script from "./AaprobarPostgrado.vue?vue&type=script&lang=js"
export * from "./AaprobarPostgrado.vue?vue&type=script&lang=js"
import style0 from "./AaprobarPostgrado.vue?vue&type=style&index=0&id=527e089e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527e089e",
  null
  
)

export default component.exports